import { concatUrl } from "../utils/concatUrl";
import {basePath} from "../utils/constants";


export const API_BASE_URL = concatUrl('/cms')
// export const API_BASE_URL = 'https://ppa-temp-domain.webstaginghub.com/cms'

class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

const handleResponse = async (response, endpoint) => {
  const contentType = response.headers.get('content-type');
  const isJson = contentType?.includes('application/json');

  if (!response.ok) {
    if (response.status === 404 || response.status >= 500) {
      const currentPath = window.location.pathname;

      if (!currentPath.startsWith(basePath)) {
        window.location.href = basePath;
        return;
      }
    }

    const errorData = isJson
      ? await response.json().catch(() => null)
      : await response.text().catch(() => null);

    throw new ApiError(
      errorData?.message || `HTTP error! status: ${response.status}`,
      response.status,
      errorData
    );
  }

  if (isJson) {
    return response.json();
  }

  return response.text();
};

const createRequest = (method) => async (endpoint, data = null, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;

  const config = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
    config.body = JSON.stringify(data);
  }

  const response = await fetch(url, config);
  return handleResponse(response, endpoint);
};

export const apiClient = {
  get: createRequest('GET'),
  post: createRequest('POST'),
  put: createRequest('PUT'),
  patch: createRequest('PATCH'),
  delete: createRequest('DELETE'),
};

export { ApiError };

